<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog"
        title="替换实施人员"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="workOrderProcessingUserReplaceForm"
                :model="workOrderProcessingUserReplaceForm"
                :rules="workOrderProcessingUserReplaceFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="原实施人员" prop="old_processing_uid">
                    <el-select
                        placeholder="请选择"
                        filterable
                        v-model="workOrderProcessingUserReplaceForm.old_processing_uid"
                    >
                        <el-option
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                            v-for="user in processingUserSelectedList"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="更改为" prop="new_processing_uid">
                    <el-select
                        placeholder="请选择"
                        filterable
                        v-model="workOrderProcessingUserReplaceForm.new_processing_uid"
                    >
                        <el-option
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                            v-for="user in processingUserList"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { roleDetail, replaceProcessingUid } from "@/api";
export default {
    name: "WorkOrderProcessingUserReplace",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        // 已经选择过的实施人员
        processing_users_selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            workOrderProcessingUserReplaceForm: {
                old_processing_uid: "",
                new_processing_uid: "",
            },
            workOrderProcessingUserReplaceFormRules: {},
            processingUserList: [],
            processingUserSelectedList: []
        };
    },
    created() {
        this.processingUserSelectedList = this.processing_users_selected.map(item=> {
            return item.processing_user
        })
        this.$nextTick(()=> {
            this.getRoleDetail()
        })
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 获取在工单实施角色中设置的范围内选择人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user"
            }).then(res=> {
                if(res.code === 200) {
                    const data = res.data || []
                    const selectedUids = this.processingUserSelectedList.map((item) => item.id);
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                    this.processingUserList = processingUserList;
                }
            })
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderProcessingUserReplaceForm.validate((valid) => {
                if (valid) {
                    const params = {
                        workorder_id: this.workorder_id,
                        old_processing_uid: this.workOrderProcessingUserReplaceForm.old_processing_uid,
                        new_processing_uid: this.workOrderProcessingUserReplaceForm.new_processing_uid,
                    };
                    if (!params.old_processing_uid || !params.new_processing_uid) return;
                    replaceProcessingUid(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message || "提交成功");
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
